// A readable message from a failed API call. The server sends either a
// sentence (`detail: "..."`) or, when a form field is invalid, a list of
// field errors whose messages read like "Value error, The end date must be…".
export const apiErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const msg = String(detail[0]?.msg || '').replace(/^Value error,\s*/i, '').trim();
    if (msg) return msg.charAt(0).toUpperCase() + msg.slice(1);
  }
  if (error && !error.response) return 'Could not reach the server. Check your connection and try again.';
  return fallback;
};
